// C:\Helpdesk\frontend\src\pages/TermsOfService.js
import React from 'react';
import PolicyPage from '../components/PolicyPage';

const TermsOfService = () => {
  return (
    <PolicyPage title="Terms of Service" lastUpdated="July 1, 2025">
      <section>
        <h2>1. Acceptance of Terms</h2>
        <p>By accessing or using the YPS Helpdesk System service, you agree to be bound by these Terms of Service. If you do not agree, you may not use our services.</p>
      </section>

      <section>
        <h2>2. Description of Service</h2>
        <p>YPS Helpdesk System provides a ticketing system for customer support and internal issue tracking. The service includes web-based software and related support services.</p>
      </section>

      <section>
        <h2>3. User Responsibilities</h2>
        <p>As a user of YPS Helpdesk System, you agree to:</p>
        <ul>
          <li>Provide accurate and complete registration information</li>
          <li>Maintain the confidentiality of your account credentials</li>
          <li>Use the service only for lawful purposes</li>
          <li>Not engage in any activity that interferes with the service</li>
        </ul>
      </section>

      <section>
        <h2>4. Prohibited Conduct</h2>
        <p>You may not:</p>
        <ul>
          <li>Use the service to transmit spam or malicious software</li>
          <li>Attempt to gain unauthorized access to any part of the service</li>
          <li>Reverse engineer, decompile, or disassemble any portion of the service</li>
          <li>Use the service to violate any laws or regulations</li>
        </ul>
      </section>

      <section>
        <h2>5. Termination</h2>
        <p>We may suspend or terminate your access to the service at any time for violation of these terms or for any other reason at our discretion.</p>
      </section>

      <section>
        <h2>6. Limitation of Liability</h2>
        <p>YPS Helpdesk System shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of the service.</p>
      </section>

      <section>
        <h2>7. Changes to Terms</h2>
        <p>We may modify these terms at any time. We will notify users of significant changes through the service or via email.</p>
      </section>

      <section>
        <h2>8. Governing Law</h2>
        <p>These terms shall be governed by the laws of the State of Delaware without regard to its conflict of law provisions.</p>
      </section>
    </PolicyPage>
  );
};

export default TermsOfService;